module.exports = __webpack_public_path__ + "media/components/ramsAnalytics/patterns/hashed-pattern-amber-0c2a8cc3b74d71640ba7c2585aa949ec.svg";